import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "trash.icon",
  "use": "trash.icon-usage",
  "viewBox": "-9579.778 -15240.43 11.558 14.859",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-9579.778 -15240.43 11.558 14.859\" id=\"trash.icon\"><path d=\"M5.826,16.208a1.656,1.656,0,0,0,1.651,1.651h6.6a1.656,1.656,0,0,0,1.651-1.651V6.3H5.826Zm2.031-5.878L9.02,9.167l1.758,1.75,1.75-1.75,1.164,1.164-1.75,1.75,1.75,1.75-1.164,1.164-1.75-1.75-1.75,1.75L7.865,13.831l1.75-1.75Zm5.812-6.505L12.842,3H8.715l-.826.826H5V5.477H16.557V3.826Z\" transform=\"translate(-9584.779 -15243.43)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/trash.icon.svg
// module id = Jut4
// module chunks = 13